import React from 'react';
import { Segment, Grid, Header, Icon } from 'semantic-ui-react';
import BusinessInfo from './BusinessInfo';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import Loading from '../../Loading';
import _ from 'lodash';
import SubscriptionInfo from './SubscriptionInfo';
import CardDetails from './CardDetails';

export const QUERY_BUSINESS_PLAN_USER = gql`
  query CurrentUser {
    user {
      id
      businessPlan {
        id
        businessname
        latestOrderNumber
        plan
        stripe {
          current_period_start
          current_period_end
          ended_at
          canceled_at
          status
          #   Customer
          #   Customer {
          #     id
          #     default_source {
          #       id
          #       last4
          #       exp_month
          #       exp_year
          #       brand
          #       name
          #     }
          #   }
        }
      }
    }
  }
`;

const Home = () => {
  const { data, loading } = useQuery(QUERY_BUSINESS_PLAN_USER);

  console.log('data>>>', data, loading);

  if (loading) {
    return <Loading />;
  }

  const businessPlan = _.get(data, 'user.businessPlan');

  console.log('businessPlan>>>', businessPlan);
  if (!businessPlan) {
    return <div>ERROR! Please Refresh</div>;
  }

  return (
    //center aligned
    <div
      className="animated fadetwoIn padded-top dnp-page"
      style={{
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Grid stackable>
        {/* <Grid.Column width={4}>
          <BusinessInfo plan={businessPlan} />
        </Grid.Column> */}

        <Grid.Column width={18}>
          <Segment raised color="blue">
            <Header as="h2" icon textAlign="center">
              <Icon name="users" circular />
              <Header.Content>Business Dashboard</Header.Content>
              <Header.Subheader>
                Keep up to date with your business subscription on the
                dashboard!
              </Header.Subheader>
            </Header>
          </Segment>
        </Grid.Column>

        {/* <Grid.Column width={5}>
          <SubscriptionInfo plan={businessPlan} />
          <CardDetails plan={businessPlan} />
        </Grid.Column> */}
      </Grid>
      <div
        style={{
          width: '50%',
          paddingTop: 20,
        }}
      >
        <p
          className="padded-top"
          style={{
            textAlign: 'center',
          }}
        >
          <i className="fa fa-info-circle" aria-hidden="true" /> Welcome to
          Deluxe Membership Business Dashboard. You have access to Profile,
          Resources, Add Family/Employees, and more.
        </p>
      </div>
    </div>
  );
};

export default Home;
